import SearchSection from './SearchSection';

export default SearchSection;
